import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export const SpamStatusMessage = ({
  isStaff = false,
}: {
  isStaff?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.spamStatusMessage}>
      <div
        className={styles.spamStatusText}
        dangerouslySetInnerHTML={{
          __html: t(
            isStaff
              ? 'Chat.SpamStatusMessage.Staff'
              : 'Chat.SpamStatusMessage.Agent'
          ),
        }}
      ></div>
    </div>
  )
}
